import { Card, CardContent, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, EditIcon, TrainIcon } from '@tom-ui/ui'
import { YardNodeHeaderTitle } from '../atoms/YardNodeHeaderTitle'

interface Props {
  id: string
  name: string
  length: number
  focused: boolean
  isEditable: boolean
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}
export const RailTrackHeader = ({
  name,
  length,
  focused,
  isEditable,
  id,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslate()

  return (
    <Card>
      <CardContent sx={{ padding: '4px !important' }}>
        <Stack spacing={2} direction='row' alignItems='center' justifyContent='space-between'>
          <YardNodeHeaderTitle title={name} icon={<TrainIcon />} />

          {focused && (
            <YardNodeHeaderTitle title={`${length}m`} description={`${t('length', 'Length')}:`} />
          )}

          {focused && isEditable && (
            <>
              <Tooltip title={t('edit', 'Edit')}>
                <IconButton onClick={() => onEdit(id)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('delete', 'Delete')}>
                <IconButton onClick={() => onDelete(id)}>
                  <BinIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
